export default '/build/6932b80c.svg'